import Vue from 'vue';
import Num2persian from 'num2persian';
Vue.use(Num2persian);

// Vue.component('num2persian', Num2persian);
